module.exports = __webpack_public_path__ + "static/media/logo.79f2cee5.png";